import Swalert from "sweetalert2";

const objetos = {
  methods: {
    //tratamento de erro
    alertErro(
      e,
      mensagem = e.response
        ? e.response.data.message
        : "Sem conexão com o servidor"
    ) {
      Swalert.fire({
        icon: "error",
        title: mensagem,
        text: e?.response?.data?.message ?? "",
      });
    },

    //alert de confirmação
    async alertAnswer(
      message = "Tem certeza que deseja realizar o procedimento?",
      text = "",
      icone = "warning"
    ) {
      return Swalert.fire({
        icon: icone,
        title: message,
        html: text,
        showCancelButton: true,
      });
    },

    //alert de alerta
    async alertWarning(message = "Verifique as informações", descricao = "") {
      return Swalert.fire({
        icon: "warning",
        title: message,
        text: descricao,
      });
    },

    async alertSuccess(
      message = "Procedimento realizado com sucesso!",
      text = ""
    ) {
      return Swalert.fire({
        icon: "success",
        title: message,
        html: text,
      });
    },
  },
};

export default objetos;
